import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { RootState } from '@/store';
import { selectAuthStatus, selectIsClaimAvailable, selectUserProfile } from '@/store/features';
import { LoginModalView, RegisterModalView } from '@/views/auth';
// import { LoginModalView, RegisterModalView, RecoveryModalView } from '@/views';
// import { LoginModalView, RegisterModalView, RecoveryModalView } from '@/views';
import { JoinRequestModal, Logo, Modal } from '@/components/shared';
import Navigation from './Navigation.component';
import AuthInfo from './AuthInfo.component';
import HamburgerMenu from './HamburgerMenu.component';
import { useModal, useVerifyConnectedAccount } from '@/hooks';
import { Notifications } from './notifications';
import WalletConnection from '@/components/shared/connections/Connections';
import { Localization } from '@/components';
import { ProfilePrivateDto } from '@/store/services/MidleNestApi.service';
import classNames from 'classnames';

interface HeaderProps {
  isAuthenticated?: boolean;
  userProfile?: ProfilePrivateDto | null;
  isRewardAvailable?: boolean;
}

function Header({ isAuthenticated = false, isRewardAvailable = false, userProfile }: HeaderProps) {
  const [isHamburgerOpened, setIsHamburgerOpened] = useState(false);
  const { showModalByLink } = useModal('login');
  const { t } = useTranslation();
  const verifyAccount = useVerifyConnectedAccount();
  useEffect(() => {
    verifyAccount();
  }, []);
  return (
    <div>
      <header className='z-20 w-full h-16 md:h-32 flex justify-center items-center md:bg-white md:dark:bg-[#202020] md:shadow-sm md:border-b md:dark:border-none border-gray-200 text-sm'>
        <nav
          className='relative w-full max-w-7xl px-4 sm:flex sm:items-center sm:justify-between'
          aria-label={t('Global')}
        >
          <div className='flex items-center justify-between w-full'>
            <NavLink className='grow-0' to='/' aria-label={t('Midle')}>
              <Logo />
            </NavLink>
            <div className='flex items-center justify-end grow'>
              <Navigation className='w-full ml-6 lg:ml-12 grow hidden lg:flex' />

              <a
                href={isAuthenticated ? '/airdrop-home' : '/airdrop'}
                className={classNames(
                  'mr-2 lg:mr-5 border border-[#FFDA68] bg-[#1A1A1A] rounded-xl w-max lg:w-52 h-14 px-3 py-2',
                  !isAuthenticated && 'hidden sm:flex',
                )}
              >
                <img src='/airdrop-logo.svg' className='w-full h-full' alt='airdrop' />
              </a>

              <div className='items-center flex mx-1'>
                {isAuthenticated && userProfile ? (
                  <AuthInfo
                    profile={userProfile}
                    isRewardAvailable={isRewardAvailable}
                    className='hidden md:flex'
                  />
                ) : (
                  <div className='flex sm:mr-2 space-x-4'>
                    <a
                      href='/login'
                      onClick={showModalByLink}
                      className='!px-6 w-max btn btn-blue dark:border-[#FFDA68] dark:text-[#FFDA68] dark:hover:bg-[#FFDA68] dark:hover:text-[#151515]'
                    >
                      {t('Login')}
                    </a>
                    {/*<a*/}
                    {/*  href='/login'*/}
                    {/*  onClick={showModalByLink}*/}
                    {/*  className='w-max px-6 py-2 font-medium text-blue-500 border border-blue-500 rounded-lg'*/}
                    {/*>*/}
                    {/*  {t('Login')}*/}
                    {/*</a>*/}
                    {/*<a*/}
                    {/*  href='/register'*/}
                    {/*  onClick={showModalByLink}*/}
                    {/*  className='w-max hidden sm:flex  px-6 py-2 font-medium text-white border bg-blue-500 rounded-lg'*/}
                    {/*>*/}
                    {/*  {t('Sign Up')}*/}
                    {/*</a>*/}
                  </div>
                )}
              </div>

              <div className='flex items-center text-xl'>
                {userProfile && (
                  <>
                    <Notifications />
                    <NavLink
                      to='/settings'
                      className='w-12 h-12 hidden lg:flex items-center justify-center rounded-full  transition-all'
                    >
                      <i className='icon-gear dark:text-white' />
                    </NavLink>
                    {/*<button*/}
                    {/*  onClick={logOut}*/}
                    {/*  className='w-12 h-12 hidden lg:flex items-center justify-center rounded-full hover:bg-gray-300 transition-all'*/}
                    {/*>*/}
                    {/*  <i className='icon-logout' />*/}
                    {/*</button>*/}
                  </>
                )}

                {!userProfile && <Localization />}

                <button
                  onClick={() => setIsHamburgerOpened(true)}
                  className='w-8 h-8 sm:w-12 sm:h-12 lg:hidden flex items-center justify-center rounded-full hover:bg-gray-300 transition-all'
                >
                  <i className='icon-menu dark:text-white' />
                </button>
              </div>
            </div>
          </div>
        </nav>
        <HamburgerMenu
          isOpened={isHamburgerOpened}
          setIsOpened={setIsHamburgerOpened}
          userProfile={userProfile}
        />
        {!userProfile && (
          <>
            <Modal id='login' className='!rounded-3xl my-20 sm:mt-24'>
              <LoginModalView />
            </Modal>
            <Modal id='register' className='!rounded-3xl my-20 sm:mt-24'>
              <RegisterModalView />
            </Modal>
            {/*<Modal id='recovery' className='!rounded-3xl my-20 sm:mt-24'>*/}
            {/*  <RecoveryModalView />*/}
            {/*</Modal>*/}
          </>
        )}
        <Modal id='wallet-connection' className='!rounded-3xl my-20 sm:mt-24'>
          <WalletConnection />
        </Modal>
        <JoinRequestModal />
      </header>
    </div>
  );
}

export default connect((state: RootState) => ({
  isAuthenticated: selectAuthStatus(state),
  userProfile: selectUserProfile(state),
  isRewardAvailable: selectIsClaimAvailable(state),
}))(Header);
